export default "__VITE_ASSET__csy8fqwu__"